import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { HomePageContainerService } from '../home-page/home-page-container.service';
import { NavigationModel } from "./navigation.model";
import { HomeScreenObject } from './tasks/home-screen.object';
import { HomePageObject } from '../home-page/home-page';
@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  
  private url ={
    fetchPanelOne:'/v2/getUserNavigator'
  };
  private allCategories:Array<any> = [];
  private options:any;

  private allScreenList :Array<any> = [];
  HOME_SCREEN_OBJECT =HomeScreenObject;
  HOME_PAGE_MODULE_OBJECT = HomePageObject;
  
  constructor(private http:HttpClient, private homeService:HomePageContainerService) { 
		this.options= {withCredentials:true}
  }

  private get clientKey(): string {
    return sessionStorage.getItem('client_key') || '';
  }
  
  navObject:{} = {};

  getUserNavigatorV2(baseUrl: string, globalParams ?: any){
    let url = baseUrl+this.url.fetchPanelOne;
     if(globalParams && globalParams.channel){
      url += `?channel_key=${globalParams.channel}&tax_year=${globalParams.taxYear}&scenario=${globalParams.scenarioKey}&scenario_type_code=${globalParams.scenarioCode}`;
     }
    return this.http.get(url)
        .pipe(
          map((res:any)=>{
            this.allScreenList = this.getAllScreens(res[0]);
            return this.transformNavigationResponseObject(res[0]);
          }
        ));
  }
  
  transformNavigationResponseObject(navResponse:NavigationModel){
    let navigation:NavigationModel[] = []; 
    navResponse.children.forEach((domain:NavigationModel) => {
      if(domain.parentTaskKey == null && domain.icon_css != null){
        navigation.push(domain);  
      }
    });

    if(navigation && navigation){
      const homeObj = navigation.filter((obj) => obj.child_id == 22505321);
      if(homeObj.length == 0 && this.HOME_PAGE_MODULE_OBJECT['home-navigator'] !=undefined){
        //navigation.push(this.HOME_PAGE_MODULE_OBJECT['home-navigator']);
        let homeNavObj = this.HOME_PAGE_MODULE_OBJECT['home-navigator'];
        navigation.push(homeNavObj);
      }
    }
    this.recursiveNavigationTasks(navigation,navResponse);
    this.navObject = this.navigationModuleObject(navigation,navResponse);
    return navigation;
  }
  navigationModuleObject(navigation:any, navResponse:any){
    let finalNavigation = {children:[]};
    finalNavigation = navResponse;
    finalNavigation['children'] = navigation;
    return finalNavigation;
  }

  recursiveNavigationTasks(navigation:NavigationModel[], navResponse:NavigationModel){

    navigation.forEach((domain:NavigationModel)=>{
      navResponse.children.forEach((subTask:NavigationModel)=>{
        if(domain.id == subTask.parentTaskKey){
          try{
            domain.children.push(subTask);
          }catch(e){
            console.error(e);
          }
        }
      });
      if(domain.children){
        this.recursiveNavigationTasks(domain.children, navResponse)
      }
    });
  }

  getAllCategories(adminUrl:string){

    return this.homeService.getTaxTypesCategories(adminUrl,parseInt(this.clientKey))
              .pipe(map(
                (res:any)=>{
                  this.allCategories = res.categoryList;
                }));
  }

  getAllScreens(navResponse:NavigationModel){
    let allScreens: Array<any> = [];

    let filterFunc = (task:any)=>{
      if(task.hasOwnProperty('children')){
        task.children.filter(filterFunc);
      }else if(task.hasOwnProperty('screens')){
        allScreens = allScreens.concat(task.screens);
      }
    };
    navResponse.children.filter(filterFunc);
    return allScreens;
  }

  getAllCategoryScreens(tasks:NavigationModel){

    let allScreens = this.getAllScreens(tasks);
    let allCategoryScreens = JSON.parse(JSON.stringify(this.allCategories));
    for(let category of allCategoryScreens){
      allScreens.forEach((screen)=>{
          if(screen["screen_categories"] && 
             screen["screen_categories"].indexOf(category.id) >= 0 ){
            category.children = category.children ||[];
            category.children.push(screen);
          }
      })
    };
    return allCategoryScreens;
  }
  
  getActivityFromTasks(task:any[]){
    let activity:  any[]=[];
    task.forEach(task=>{
      activity = activity.concat(task.children);
    })
    return activity;
  }
  
  filterBySearch(listObj:any, searchText:string,type:'tax-type'|'categories'){
    const query = (searchText || '').trim();
    if(query === '') return listObj;
    return this.recursiveFilterMethod(listObj, query);
  }

  recursiveFilterMethod(list:any, searchText:string){
    const query = searchText.toLowerCase();
    const getNodeText = (node: any): string => {
      const candidates = [
        node?.label,
        node?.text,
        node?.name,
        node?.SCREEN_NAME,
        node?.ACTIVITY_NAME,
        node?.BRDCUMB,
        node?.breadcrumb
      ];
      for (const value of candidates) {
        if (value !== null && value !== undefined) {
          const resolved = String(value).trim();
          if (resolved) {
            return resolved.toLowerCase();
          }
        }
      }
      return '';
    };

    const matchNode = (node: any): boolean => {
      const selfMatch = getNodeText(node).includes(query);

      if (!selfMatch) {
        if (Array.isArray(node?.children)) {
          // Preserve the canonical (unfiltered) list before mutating so any
          // downstream consumer walking `screen.parent` after a search click
          // still has a reliable handle on the original sibling set. The
          // workspace navigation flow does not depend on this fallback (it
          // re-resolves from USER_MENU via `activity_key`), but keeping the
          // original arrays accessible avoids future regressions if anyone
          // reads `parent.screens` directly.
          if (!node.__canonicalChildren) {
            node.__canonicalChildren = node.children;
          }
          node.children = node.children.filter((child: any) => matchNode(child));
        }

        if (Array.isArray(node?.screens)) {
          if (!node.__canonicalScreens) {
            node.__canonicalScreens = node.screens;
          }
          node.screens = node.screens.filter((screen: any) => matchNode(screen));
        }
      }

      const hasChildren = Array.isArray(node?.children) && node.children.length > 0;
      const hasScreens = Array.isArray(node?.screens) && node.screens.length > 0;
      return selfMatch || hasChildren || hasScreens;
    };

    return (Array.isArray(list) ? list : []).filter((item: any) => matchNode(item));
  }

  getCurrentScreen(currentScreen:{currentState:string}){
    let filteredScreen:any = [];
    if (!currentScreen?.currentState) {
      return filteredScreen;
    }
    this.allScreenList.forEach( screen => {
     if( screen.link == currentScreen.currentState){
      filteredScreen.push(screen);
     }
    })
    if(filteredScreen.length == 0){
      filteredScreen[0]=this.HOME_SCREEN_OBJECT;
      return filteredScreen;
    }

    return [];
  }
}
